import { callFunction } from "./functions-client";

// Marketing campaigns over CRM contacts (LOS Phase 13).
export const CAMPAIGN_CHANNELS = ["email", "sms"] as const;

export interface Campaign {
  id: string;
  name: string;
  channel: string;
  subject?: string | null;
  body?: string | null;
  audience_type?: string | null;
  audience_status?: string | null;
  status: "draft" | "sent";
  recipient_count: number;
  sent_at?: string | null;
  updated_at?: string;
}

export interface CampaignStats { sent: number; open: number; click: number; convert: number }

export interface NewCampaign {
  name: string;
  channel?: string;
  subject?: string;
  body?: string;
  audience_type?: string;
  audience_status?: string;
}

function qs(params: Record<string, string | undefined>): string {
  const e = Object.entries(params).filter(([, v]) => v);
  return e.length ? "?" + new URLSearchParams(e as [string, string][]).toString() : "";
}

export const listCampaigns = () =>
  callFunction<{ campaigns: Campaign[] }>("marketing/list", { method: "GET" });

export const getCampaign = (id: string) =>
  callFunction<{ campaign: Campaign; stats: CampaignStats }>(`marketing/get?id=${encodeURIComponent(id)}`, { method: "GET" });

export const createCampaign = (input: NewCampaign) =>
  callFunction<{ campaign: Campaign }>("marketing/create", { body: input });

export const updateCampaign = (input: { id: string } & Partial<NewCampaign>) =>
  callFunction<{ ok: boolean }>("marketing/update", { body: input });

export const previewAudience = (audience_type?: string, audience_status?: string) =>
  callFunction<{ count: number }>(`marketing/audience-preview${qs({ audience_type, audience_status })}`, { method: "GET" });

export const sendCampaign = (id: string) =>
  callFunction<{ ok: boolean; recipient_count: number }>("marketing/send", { body: { id } });
